import React, { FC } from 'react';
import { TrendingDown, TrendingFlat, TrendingUp } from '@mui/icons-material';

interface Props {
  growth: number;
}

const GrowthIndicator: FC<Props> = ({ growth }) => {
  return (
    <>
      {growth > 0 && <TrendingUp color="success" />}
      {growth === 0 && <TrendingFlat color="warning" />}
      {growth < 0 && <TrendingDown color="error" />}
    </>
  );
};

export default GrowthIndicator;
